import React, { useState } from "react";

const APPS = [
  { 
    id: "slack", 
    name: "COMM//LINK", 
    icon: "💬",
    gradient: "from-purple-500 to-pink-500"
  },
  { 
    id: "files", 
    name: "Fichiers", 
    icon: "📁",
    gradient: "from-blue-500 to-cyan-500"
  },
];

function DesktopIcon({ app, onDoubleClick }) {
  const [clickCount, setClickCount] = useState(0);
  const [clickTimer, setClickTimer] = useState(null);

  const handleClick = () => {
    setClickCount(prev => prev + 1);
    
    if (clickTimer) {
      clearTimeout(clickTimer);
    }
    
    const timer = setTimeout(() => {
      if (clickCount + 1 >= 2) {
        onDoubleClick(app.id);
      }
      setClickCount(0);
    }, 300);
    
    setClickTimer(timer);
  };

  return (
    <button
      onClick={handleClick}
      className="flex flex-col items-center gap-2 p-4 rounded-lg hover:bg-white/10 transition-colors group"
    >
      <div className={`w-16 h-16 bg-gradient-to-br ${app.gradient} rounded-xl flex items-center justify-center text-3xl shadow-lg group-hover:scale-110 transition-transform`}>
        {app.icon}
      </div>
      <div className="text-xs text-white font-medium text-center px-2 py-1 bg-black/40 rounded backdrop-blur-sm">
        {app.name}
      </div>
    </button>
  );
}

export default function Desktop({ onOpenApp, onBack }) {
  const [time, setTime] = useState(new Date());

  React.useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative w-full h-[75vh] bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 rounded-xl overflow-hidden border border-slate-700">
      {/* Wallpaper pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>
      
      {/* Desktop icons */}
      <div className="relative z-10 p-8 grid grid-cols-4 gap-4 content-start h-full">
        {APPS.map(app => (
          <DesktopIcon 
            key={app.id} 
            app={app} 
            onDoubleClick={onOpenApp}
          />
        ))}
      </div>
      
      {/* Taskbar */}
      <div className="absolute bottom-0 left-0 right-0 h-12 bg-slate-950/80 backdrop-blur border-t border-slate-700 flex items-center justify-between px-4">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-cyan-500 rounded flex items-center justify-center text-white font-bold text-sm">
            F
          </div>
          <div className="text-xs text-slate-400">Fenêtre Visto</div>
        </div>
        
        <div className="flex items-center gap-4">
          <div className="text-xs text-white font-mono">
            {time.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
          </div>
          <div className="text-xs text-slate-400">
            {time.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })}
          </div>
        </div>
      </div>
    </div>
  );
}